import React, { useEffect, useState } from "react";
import { states } from "../../services/state";
import authApiService from "../../services/authServices";

const CourtsSelection = ({
  formData,
  handleInputChange,
  isEditMode = false,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [courts, setCourts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
        const cityId = selectedCity?.id;

        // If editing an existing user, include their current courtId so that
        // even if the court was deleted/inactivated, it still appears in the dropdown.
        const currentCourtId =
          isEditMode && formData.court_id ? formData.court_id : null;

        const params = { cityId };
        if (currentCourtId) params.currentCourtId = currentCourtId;

        const response = await authApiService.get("cityCourts", params);
        console.log("signup", response.data);

        if (response.data && response.data.length > 0) {
          setCourts(response.data);
        } else {
          setCourts([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setCourts([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="edituser-section col-sm-12 col-lg-3">
      <fieldset>
        <legend>
          Court Selection <span className="mandatory">*</span>{" "}
        </legend>
        {!isEditMode && courts.length > 0 && (
          <div className="styled-input">
            <label>Select Court</label>
            <select
              id="court_id"
              name="court_id"
              value={formData.court_id}
              onChange={(e) => {
                handleInputChange(e);
                const homeCourtDiv = document.getElementById("homeCourtDiv");
                homeCourtDiv.style.display =
                  e.target.value === "-1" ? "block" : "none";
              }}
            >
              <option value="" disabled>
                Please Select
              </option>
              {courts.map((court) => (
                <option key={court.id} value={court.id}>
                  {court.name}
                </option>
              ))}
              <option value="-1">Enter New Court</option>
            </select>
          </div>
        )}
        <div
          id="homeCourtDiv"
          style={{
            display: isEditMode || courts.length === 0 ? "block" : "none",
          }}
        >
          <label htmlFor="home_court" className="floating-label">
            Home Court <span className="mandatory">*</span>
          </label>
          <div className="floating-label-wrap">
            <input
              id="home_court"
              name="home_court"
              className="longBox floating-label-field floating-label-field--s3"
              type="text"
              value={formData.home_court}
              onChange={handleInputChange}
              maxLength={30}
            />
          </div>
          <div className="floating-label-wrap">
            <label htmlFor="court_address" className="floating-label">
              Address<span className="mandatory">*</span>
            </label>
            <input
              id="court_address"
              name="court_address"
              className="longBox floating-label-field floating-label-field--s3"
              type="text"
              value={formData.court_address}
              onChange={handleInputChange}
              maxLength={30}
            />
          </div>
          <div className="floating-label-wrap">
            <label htmlFor="court_city" className="floating-label">
              City<span className="mandatory">*</span>
            </label>
            <input
              id="court_city"
              name="court_city"
              className="longBox floating-label-field floating-label-field--s3"
              type="text"
              value={formData.court_city}
              onChange={handleInputChange}
              maxLength={30}
            />
          </div>
          {/* <div className="styled-input">
            <label htmlFor="court_state">
              State<span className="mandatory">*</span>
            </label>
            <select
              id="court_state"
              name="court_state"
              className="sixcol"
              value={formData.court_state}
              onChange={handleInputChange}
            >
              {states.map((state, index) => (
                <option key={index} value={state.code}>{state.name}</option>
              ))}
            </select>
          </div> */}
          <div className="styled-input">
            <label className="mt-2">Lighted</label>
            <select
              id="court_lighted"
              name="court_lighted"
              className="sixcol"
              value={formData.court_lighted}
              onChange={handleInputChange}
            >
              <option value="" />
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </select>
          </div>
          <div className="styled-input">
            <label>Number of Courts</label>
            <select
              id="numberOfCourts"
              name="numberOfCourts"
              className="sixcol"
              value={formData.numberOfCourts}
              onChange={handleInputChange}
            >
              <option value="" />
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
          </div>
          <div className="styled-input hour-open">
            <label>Hours Open</label>
            <select
              id="openCourtMeridiem"
              name="openCourtMeridiem"
              className="sixcol"
              value={formData.openCourtMeridiem}
              onChange={handleInputChange}
            >
              <option value="" />
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
            <select
              id="openCourtHour"
              name="openCourtHour"
              className="sixcol"
              value={formData.openCourtHour}
              onChange={handleInputChange}
            >
              <option value="" />
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
          </div>
          <div className="styled-input hour-close">
            <label>Hours Close</label>
            <select
              id="closeCourtMeridiem"
              name="closeCourtMeridiem"
              className="sixcol"
              value={formData.closeCourtMeridiem}
              onChange={handleInputChange}
            >
              <option value="" />
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
            <select
              id="closeCourtHour"
              name="closeCourtHour"
              className="sixcol"
              value={formData.closeCourtHour}
              onChange={handleInputChange}
            >
              <option value="" />
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
              <option value="11">11</option>
              <option value="12">12</option>
            </select>
          </div>
        </div>
      </fieldset>

      <fieldset className="other-info">
        <legend>Other Information</legend>
        <div className="styled-input">
          <label htmlFor="referral">
            How did you find us<span className="mandatory">*</span>
          </label>
          <select
            id="referral"
            name="referral"
            value={formData.referral}
            onChange={handleInputChange}
          >
            <option value="" disabled>
              Please Select
            </option>
            <option value="Web Search">Web Search</option>
            <option value="Online Advertising">Online Advertising</option>
            <option value="Poster At Tennis Court">
              Poster At Tennis Court
            </option>
            <option value="Poster At Tennis Club">Poster At Tennis Club</option>
            <option value="Poster Elsewhere">Poster Elsewhere</option>
            <option value="Email Newsletter">Email Newsletter</option>
            <option value="Friend">Friend</option>
            <option value="Other">Other</option>
          </select>
        </div>
      </fieldset>
    </div>
  );
};

export default CourtsSelection;
